const PlanCard = ({
  duration,
  monthlyFee,
  admissionFee,
  description,
  fee,
  isStudent,
  isPersonalTraining,
}) => {
  return (
    <div
      className="bg-white rounded-xl shadow-lg text-center flex flex-col justify-between
      h-[420px] w-[300px] p-6 transition-transform duration-300 hover:scale-105"
    >
      {/* Title */}
      <div>
        {isPersonalTraining ? (
          <h3 className="text-xl font-semibold mb-8">{description}</h3>
        ) : (
          <h3 className="text-xl font-semibold mb-8">{duration}</h3>
        )}
      </div>

      {/* Price */}
      <div className="flex-grow flex flex-col items-center justify-center">
        <p className="text-5xl font-extrabold text-accent">
          {isPersonalTraining ? `₹${fee}` : `₹${monthlyFee}`}
        </p>
      </div>

      {/* Extra Info */}
      <div className="text-base text-gray-600">
        {isPersonalTraining ? (
          <p className="mb-2">Package – No registration required</p>
        ) : admissionFee ? (
          <p className="mb-2">
            Admission Fee: <span className="font-semibold">₹{admissionFee}</span> (One-time)
          </p>
        ) : (
          <p className="mb-2">Non-Registrable</p>
        )}
      </div>
    </div>
  );
};

export default PlanCard;
